export const GET_ROTATE_POSITIONS = 'GET_ROTATE_POSITIONS';
export const GET_ROTATE_POSITIONS_SUCCESS = 'GET_ROTATE_POSITIONS_SUCCESS';
export const GET_ROTATE_POSITIONS_ERROR = 'GET_ROTATE_POSITIONS_ERROR';
